var map = {
	"./ACE.png": 2296,
	"./Ecoagro.png": 2297,
	"./IDtrust.png": 2298,
	"./Kanastra.png": 2299,
	"./Laqus.png": 2300,
	"./Liberum.png": 2301,
	"./Madrona.png": 2302,
	"./Master.png": 2303,
	"./Next.png": 2304,
	"./Nuclea.png": 2305,
	"./OuroPreto.png": 2306,
	"./PinheiroNeto.png": 2307,
	"./SantosNeto.png": 2308,
	"./Singulare.png": 2309,
	"./SolisInvestimentos.png": 2310,
	"./Tercon.png": 2311,
	"./TozziniFreire.png": 2312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2295;